@use 'vars';

//It is import to keep this as
//14 so layout shift doesn't happen when animating
$IQ_CURSOR_ORB_SIZE: 14px;

.iq-cursor-orb {
  content: '';
  display: inline-block;
  width: $IQ_CURSOR_ORB_SIZE;
  height: $IQ_CURSOR_ORB_SIZE;
  border-radius: vars.$border-radius-circle;
  background-color: vars.$dark-grey;
  //center the orb in the text
  margin-bottom: -2px;

  &--slow {
    animation: pulse 1s infinite;
  }

  &--medium {
    animation: pulse 0.5s infinite;
  }

  &--fast {
    animation: pulse 0.3s infinite;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
}
